import { render, staticRenderFns } from "./organization_document.vue?vue&type=template&id=3dabbf05&scoped=true"
import script from "./organization_document.vue?vue&type=script&lang=js"
export * from "./organization_document.vue?vue&type=script&lang=js"
import style0 from "./organization_document.vue?vue&type=style&index=0&id=3dabbf05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dabbf05",
  null
  
)

export default component.exports